import * as React from "react";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import LoadingFullScreen from "../../../components/LoadingFullScreen";
import { RootState, MessageTemplate, Page, FamilyMember, FamilyMemberSms } from "../../types";
import { sendUnsecureMessage, sendSecureMessage, getFamilyMessageTemplateList } from "../actions";
import MessageFamily from "../components/MessageFamily";
import flash from "../../flash/actions";
import { Organization } from "../../organizations/types";
import { Patient } from "../../patient/types";
import { getFamilyMembers } from "../../patient/actions";
import ErrorMessage from "../../../components/ErrorMessage";

interface StoreProps {
  patient_loading: boolean;
  loading: boolean;
  patient: Patient | null;
  familyMembersPage: Page<FamilyMember> | null;
  messageTemplateList: Page<MessageTemplate> | null;
  currentOrg: Organization | null;
  errorMessage: string | null;
}

interface DispatchProps {
  getFamilyMembers: (patientId: string) => void;
  sendUnsecureMessage: (patient: Patient, message: string, familyMemberIds: string[]) => void;
  sendSecureMessage: (
    patient: Patient,
    familyMembers: FamilyMemberSms[],
    message?: string,
    attachments?: string[]
  ) => void;
  getFamilyMessageTemplateList: () => void;
  flash: (body: string, level: "error") => void;
}

interface OwnState {}

type Props = OwnState & DispatchProps & StoreProps & RouteComponentProps<{ patientId: string }>;

class MessageFamilyContainer extends React.PureComponent<Props, OwnState> {
  public constructor(props: Props) {
    super(props);
    this.state = {};
  }

  public componentDidMount() {
    this.props.getFamilyMessageTemplateList();
    this.props.getFamilyMembers(this.props.match.params.patientId);
  }

  public render() {
    const {
      patient_loading,
      loading,
      patient,
      sendUnsecureMessage,
      sendSecureMessage,
      messageTemplateList,
      flash,
      currentOrg,
      errorMessage
    } = this.props;
    const { familyMembersPage } = this.props;
    return (
      <>
        {(loading || patient_loading) && <LoadingFullScreen />}
        {errorMessage && <ErrorMessage message={errorMessage} />}
        <MessageFamily
          sendUnsecureMessage={sendUnsecureMessage}
          sendSecureMessage={sendSecureMessage}
          patient={patient}
          familyMembersPage={familyMembersPage}
          messageTemplateList={messageTemplateList}
          flash={flash}
          currentOrg={currentOrg}
        />
      </>
    );
  }
}

export default connect<StoreProps, DispatchProps, {}, RootState>(
  state => ({
    patient_loading: state.patientdetail.loading,
    loading: state.messagefamily.loading,
    patient: state.patientdetail.data.patient,
    familyMembersPage: state.patientdetail.data.familyMembers,
    messageTemplateList: state.messagefamily.data.messageTemplateList,
    errorMessage: state.messagefamily.errorMessage,
    currentOrg: state.orgs.currentOrganization
  }),
  {
    getFamilyMembers,
    sendUnsecureMessage,
    sendSecureMessage,
    getFamilyMessageTemplateList,
    flash
  }
)(MessageFamilyContainer);
